import { createFileRoute } from "@tanstack/react-router";
import { useApp } from "@/context/AppContext";
import { KundenRedaktionsplan } from "@/pages/client/KundenRedaktionsplan";
import { Redaktionsplan } from "@/pages/team/Redaktionsplan";

/**
 * Eine Adresse, zwei Sichten (Etappe 6): Das Team plant je Kunde, ein
 * Kundenkonto sieht seinen Plan — oder die gesperrte Ansicht, solange die
 * Social-Media-Betreuung nicht gebucht ist. Ob die Tür offen ist,
 * entscheidet das Backend an jeder Route, nicht dieses Menü.
 */
export const Route = createFileRoute("/_angemeldet/redaktionsplan")({
	validateSearch: (
		suche: Record<string, unknown>,
	): { kunde?: string; beitrag?: string; ki?: boolean } => ({
		kunde: typeof suche.kunde === "string" ? suche.kunde : undefined,
		beitrag: typeof suche.beitrag === "string" ? suche.beitrag : undefined,
		// KI-Werkstatt offen (die Glocke verlinkt mit ?ki=1)
		ki: suche.ki === true || suche.ki === "1" || suche.ki === 1 ? true : undefined,
	}),
	component: RedaktionsplanSeite,
});

function RedaktionsplanSeite() {
	const { role } = useApp();
	return role === "mitarbeiter" ? <Redaktionsplan /> : <KundenRedaktionsplan />;
}
